/**
 * 验证方法集合
 */
/**
 * 验证是否在微信环境中
 * 2021-06-02 18:13:51
 * @author SnowRock
 * @returns {boolean}
 */
export function isWeChat() {
    return isInNavigator('micromessenger')
}

/**
 * 判断浏览器的user-agent信息是否包含字符
 * @param vg 字符
 * @returns {boolean}
 */
export function isInNavigator(vg) {
    if (typeof navigator === 'undefined') {
        return false
    }
    if (typeof vg === 'undefined') {
        return false
    }
    var agent = navigator.userAgent.toLowerCase()
    return agent.indexOf(vg.toLowerCase()) > -1
}
export function getNowTime (type = 0) {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let second = date.getSeconds();
    let formattedTime = type ? (month < 10 ? "0" : "") + month + "-" + 
    (day < 10 ? "0" : "") + day + " " + 
    (hour < 10 ? "0" : "") + hour + ":" + 
    (minute < 10 ? "0" : "") + minute + ":" + 
    (second < 10 ? "0" : "") + second : year + "-" + 
    (month < 10 ? "0" : "") + month + "-" + 
    (day < 10 ? "0" : "") + day + " " + 
    (hour < 10 ? "0" : "") + hour + ":" + 
    (minute < 10 ? "0" : "") + minute + ":" + 
    (second < 10 ? "0" : "") + second;
    return formattedTime
}
export function timestampToDatetime (timestamp, type = 0) {
    let date = new Date(timestamp);
    let year = date.getFullYear();
    let month = date.getMonth() + 1
    let day = date.getDate() 
    let hour = date.getHours() 
    let minute = date.getMinutes() 
    let second = date.getSeconds() 
    let formattedTime = !type ? (month < 10 ? "0" : "") + month + "-" + 
    (day < 10 ? "0" : "") + day + " " + 
    (hour < 10 ? "0" : "") + hour + ":" + 
    (minute < 10 ? "0" : "") + minute + ":" + 
    (second < 10 ? "0" : "") + second : 1 == type ? year + "-" + 
    (month < 10 ? "0" : "") + month + "-" + 
    (day < 10 ? "0" : "") + day + " " + 
    (hour < 10 ? "0" : "") + hour + ":" + 
    (minute < 10 ? "0" : "") + minute + ":" + 
    (second < 10 ? "0" : "") + second : (month < 10 ? "0" : "") + month + "月" + 
    (day < 10 ? "0" : "") + day + "日 " + 
    (hour < 10 ? "0" : "") + hour + ":" + 
    (minute < 10 ? "0" : "") + minute + ":" + 
    (second < 10 ? "0" : "") + second;
    return formattedTime
}

export function timestampMountDay (timestamp) {
    let date = timestamp ? new Date(timestamp) : new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1
    let day = date.getDate() 
    let formattedTime = (month < 10 ? "0" : "") + month + "-" + 
    (day < 10 ? "0" : "") + day + " " 
    return [formattedTime, year]
}